<div class="flex min-h-screen">
  <!-- Left Side (Blurred Card Section) -->
  <div
    class="w-1/2 flex items-center justify-center bg-cover bg-center relative overflow-hidden rounded-r-2xl"
    style="background-image: url('/Untitled design.png')">
  </div>

  <!-- Right Side (Login Form Section) -->
  <div class="w-1/2 flex items-center justify-center bg-white px-8">
    <div class="w-full max-w-sm">
      <h2 class="text-3xl font-bold text-gray-800 mb-6 text-center">WatchDog Login</h2>

      <form class="mb-6">
        <div class="mb-4">
          <label for="username" class="block text-gray-600 mb-2">Username</label>
          <input
            id="username"
            type="text"
            class="w-full p-3 rounded-3xl bg-gray-100 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your username">
        </div>

        <div class="mb-4">
          <label for="password" class="block text-gray-600 mb-2">Password</label>
          <input
            id="password"
            type="password"
            class="w-full p-3 rounded-3xl bg-gray-100 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your password">
        </div>

        <button
          type="submit"
          class="w-full bg-blue-500 text-white p-3 rounded-3xl font-medium hover:bg-blue-600 transition cursor-pointer">
          Login
        </button>
      </form>

      <div class="flex items-center mb-4">
        <div class="flex-grow border-t border-gray-400"></div>
        <span class="text-gray-400 text-center mx-4">or</span>
        <div class="flex-grow border-t border-gray-400"></div>
      </div>

      <button
        (click)="login()"
        class="w-full flex items-center justify-center bg-gray-100 text-gray-800 p-3 rounded-3xl font-medium hover:bg-gray-200 transition cursor-pointer">
        Login with Keycloak
      </button>
    </div>
  </div>
</div>
